import { Box } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { ContainerPage, TitlePage } from "components";

import { DialogUpload } from "./DialogUpload";
import { useStyles } from "./styles";

export default function PurchaseRequest() {
  const classes = useStyles();

  return (
    <ContainerPage>
      <Box display="flex" justifyContent="space-between" flexWrap="wrap">
        <TitlePage>Requisição de compra</TitlePage>
      </Box>

      <Box display="flex" justifyContent="center" width="100%">
        <Alert severity="info" className={classes.acceptedColumnsAlert}>
          O arquivo deve conter as seguintes colunas na mesma ordem:
          product_base_id, quantity.
        </Alert>
      </Box>

      <Box display="flex" justifyContent="center" flexWrap="wrap">
        <DialogUpload />
      </Box>
    </ContainerPage>
  );
}
